import { Color } from 'three';
import type { ZoneType } from '../types/core';

export const palette = {
  grassA: '#91b765',
  grassB: '#7fa85a',
  road: '#5b6266',
  roadEdge: '#5b626688',
  pavement: '#c9c3ad',
  honey: '#e6a83f',
  cream: '#f6ead1',
  brick: '#a95b3d',
  night: '#172638',
  rain: '#8fb5bd'
} as const;

export function zoneColour(zone?: ZoneType): string {
  if (!zone) {
    return palette.grassA;
  }

  const colours: Record<ZoneType, string> = {
    residential: '#b8c879',
    commercial: '#cba15f',
    workspace: '#a58d70',
    park: '#78a95c'
  };

  return colours[zone];
}

export function activityColour(activity: string): string {
  if (activity === 'Working') {
    return '#4f7d97';
  }
  if (activity === 'Shopping') {
    return '#e6a83f';
  }
  if (activity === 'Relaxing') {
    return '#5f9866';
  }
  if (activity === 'Commuting') {
    return '#d26b49';
  }
  if (activity === 'Sleeping') {
    return '#6b6f95';
  }
  return '#f6ead1';
}

export function colourForTime(minuteOfDay: number, weatherCloudCover: number): Color {
  const night = new Color('#111b2b');
  const dawn = new Color('#f3c66f');
  const day = new Color('#a8d7eb');
  const dusk = new Color('#d58b68');
  const t = minuteOfDay / 1440;
  const colour = new Color();

  if (t < 0.24) {
    colour.lerpColors(night, dawn, t / 0.24);
  } else if (t < 0.35) {
    colour.lerpColors(dawn, day, (t - 0.24) / 0.11);
  } else if (t < 0.76) {
    colour.copy(day);
  } else if (t < 0.88) {
    colour.lerpColors(day, dusk, (t - 0.76) / 0.12);
  } else {
    colour.lerpColors(dusk, night, (t - 0.88) / 0.12);
  }

  colour.lerp(new Color('#9fb4bc'), weatherCloudCover * 0.35);
  return colour;
}
